//
//  SDKDocumentationLegacyHeadingType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyHeadingType;
(function (DocumentationLegacyHeadingType) {
    DocumentationLegacyHeadingType[DocumentationLegacyHeadingType["h1"] = 1] = "h1";
    DocumentationLegacyHeadingType[DocumentationLegacyHeadingType["h2"] = 2] = "h2";
    DocumentationLegacyHeadingType[DocumentationLegacyHeadingType["h3"] = 3] = "h3";
    DocumentationLegacyHeadingType[DocumentationLegacyHeadingType["h4"] = 4] = "h4";
    DocumentationLegacyHeadingType[DocumentationLegacyHeadingType["h5"] = 5] = "h5";
})(DocumentationLegacyHeadingType || (DocumentationLegacyHeadingType = {}));
